import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import reactGa from 'react-ga';
import { initGtm, initGa, trackEventGtm, trackEventGa } from './utils';
import AnalyticsContext from './context';

const helpers = {
  ga: {
    init: initGa,
    trackEvent: trackEventGa,
  },
  gtm: {
    init: initGtm,
    trackEvent: trackEventGtm,
  },
};

const Analytics = ({ location, analyticsProvider, analyticsId, children }) => {
  const isGa = analyticsProvider === 'ga';
  const timeoutRef = useRef();

  // initialize analytics
  useEffect(() => {
    const { init } = helpers[analyticsProvider];
    init(analyticsId);
  }, [analyticsProvider, analyticsId]);

  // track pageviews
  useEffect(() => {
    const path = location.pathname + location.search;
    // with GTM, pageviews are tracked by configuring the historyChange trigger
    // so we don't do anything special here
    if (isGa) {
      // timeout to ensure page metadata is updated before pageview is sent
      timeoutRef.current = setTimeout(() => {
        reactGa.set({ page: path });
        reactGa.pageview(path);
      });
    }
    return () => clearTimeout(timeoutRef.current);
  }, [isGa, location.pathname, location.search]);

  const { trackEvent } = helpers[analyticsProvider];
  const trackMediaPlay = source => {
    trackEvent({
      category: 'media',
      action: 'play',
      label: source,
    });
  };
  const trackMediaProgress = (source, percentVal) => {
    trackEvent({
      category: 'media',
      action: `progress-${percentVal}-percent`,
      label: source,
    });
  };

  return (
    <AnalyticsContext.Provider value={{ trackEvent, trackMediaPlay, trackMediaProgress }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

Analytics.propTypes = {
  location: PropTypes.object,
  analyticsProvider: PropTypes.oneOf(['ga', 'gtm']).isRequired,
  analyticsId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
};

export default withRouter(Analytics);
